import { AxiosResponse } from 'axios';
import { IGridResponse } from '@models/response/IGridResponse';
import { IDataGridDescriptionResponse } from '@models/response/IDataGridDescriptionResponse';
import { IGridExportSettings } from '@models/response/IGridExportSettings';
import { IDocumentResult } from '@models/document/IDocumentResult';
import { IBackgroundJobStarted } from '@models/backgroundJobs/IBackgroundJob';

export abstract class IDataGridService {
    abstract fetchScheme(data: any): Promise<AxiosResponse<IDataGridDescriptionResponse>>; // Mandatory
    abstract fetchData(data: any, loadOptions: any, signal?: AbortSignal): Promise<AxiosResponse<IGridResponse>>; // Mandatory
    abstract putData(data: any): Promise<AxiosResponse<IDocumentResult, any>>;
    abstract fetchDetailData(data: any, detailData: any, loadOptions: any): Promise<AxiosResponse<IGridResponse>>; // Mandatory
    abstract exportData(template: string, options: any, columns: IGridExportSettings[], maxItemsCount?: number): Promise<void>;
    /** Та же выгрузка фоновой задачей (ответ 202); нет метода — у набора только обычная выгрузка. */
    exportDataInBackground?(
        template: string,
        options: any,
        columns: IGridExportSettings[],
        maxItemsCount?: number,
    ): Promise<IBackgroundJobStarted>;
    /** Необязательный стабильный cursor: строка → нулевая страница текущей выборки. */
    fetchRowPage?(
        data: any,
        rowId: string,
        loadOptions: any,
        signal?: AbortSignal,
    ): Promise<AxiosResponse<number | null>>;
}
